import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['scroll'];
    static values = {
        upClass: { type: String, default: 'can-scroll-up' },
        downClass: { type: String, default: 'can-scroll-down' },
    }

    #hasLenisPrevent = false

    scrollTargetConnected(target) {
        this.#hasLenisPrevent = target.hasAttribute('data-lenis-prevent')
        this.update()
    }

    update() {
        if (!this.hasScrollTarget) {
            return
        }

        const canScrollUp = this.scrollTarget.scrollTop >= 2
        const canScrollDown = this.scrollTarget.scrollTop < (this.scrollTarget.scrollHeight - this.scrollTarget.offsetHeight - 2)

        this.element.classList.toggle(this.upClassValue, canScrollUp)
        this.element.classList.toggle(this.downClassValue, canScrollDown)

        this.#updateLenisPrevent(canScrollUp || canScrollDown)
    }

    #updateLenisPrevent(state) {
        if (!this.#hasLenisPrevent) {
            return
        }

        if (state) {
            if (!this.scrollTarget.hasAttribute('data-lenis-prevent')) {
                this.scrollTarget.setAttribute('data-lenis-prevent', '')
            }
        } else {
            if (this.scrollTarget.hasAttribute('data-lenis-prevent')) {
                this.scrollTarget.removeAttribute('data-lenis-prevent')
            }
        }
    }
}
